// extracted by mini-css-extract-plugin
export default {"nftHistoryContainer":"NftHistory_nftHistoryContainer__SIUAd","historyBackground":"NftHistory_historyBackground__Lyk+9"};